import { render, staticRenderFns } from "./StmpEmail.vue?vue&type=template&id=a1d70178&scoped=true"
import script from "./StmpEmail.vue?vue&type=script&lang=js"
export * from "./StmpEmail.vue?vue&type=script&lang=js"
import style0 from "./StmpEmail.vue?vue&type=style&index=0&id=a1d70178&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d70178",
  null
  
)

export default component.exports